/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Invoke_Api_Batch_DeclinedInputs */



/**
* | output |
* | --- |
* | "{count} declined" |
*
* @param {Chat_Invoke_Api_Batch_DeclinedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_invoke_api_batch_declined = /** @type {((inputs: Chat_Invoke_Api_Batch_DeclinedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Invoke_Api_Batch_DeclinedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} abgelehnt`)
	return /** @type {LocalizedString} */ (`${i?.count} declined`)
});